import { link } from "fs";
import { ISeo } from "interfaces/intarfaces";
import React from "react";
import { Helmet } from "react-helmet";

export const HeaderSEO: React.FC<ISeo> = ({
  title:
    title_txt = "Platform voor hospitaverhuur & kamerverhuur | Hospi Housing",
  keywords = "dvies en begeleiding bij het verhuren van een kamer in huis. Voor hosts, gastgezinnen en verhuurders geheel gratis.",
  description = "Hospitaverhuur, kamerverhuur, hospita, gastgezin, onderverhuur",
  canonicallink = "https://hospihousing.com/nl/"
}) => {
  return (
    <Helmet>
      {title_txt && !!title_txt.length && <title>{title_txt}</title>}
      {keywords && !!keywords.length && (
        <meta name="keywords" content={keywords} />
      )}
      {description && !!description.length && (
        <meta name="description" content={description} />
      )}

      {canonicallink && !!canonicallink.length && (
        <link rel="canonical" href={canonicallink} />
      )}
    </Helmet>
  );
};
